import { Button } from "@/components/ui/button";
import { PencilIcon } from "@/components/developer/DashboardIcons";
import { format } from "date-fns";

interface Certification {
  id: string;
  name: string;
  issuer?: string | null;
  issued_date?: string | null;
}

interface CertificationListProps {
  certifications: Certification[];
  onEdit: (certification: Certification) => void;
}

const CertificationList = ({ certifications, onEdit }: CertificationListProps) => {
  return (
    <div className="space-y-6">
      {certifications.map((certification) => (
        <div key={certification.id} className="group relative">
          <div className="flex justify-between mb-2">
            <div>
              <h3 className="font-semibold">{certification.name}</h3>
              {certification.issuer && (
                <p className="text-sm text-gray-600">{certification.issuer}</p>
              )}
            </div>
            <div className="flex items-start gap-2">
              <p className="text-sm text-gray-600">
                {certification.issued_date && format(new Date(certification.issued_date), 'MMMM yyyy')}
              </p>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(certification)}
              >
                <PencilIcon className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CertificationList;